module.exports = __webpack_public_path__ + "static/media/20240530085320_IMG_7474.ad4af35c.JPG";